<ng-content *ngIf="_active"></ng-content>
